import { createSlice } from "@reduxjs/toolkit";

const addresses = createSlice({
    name: "userAddresses",
    initialState: {
        addresses: [],
        isLoaded: false,
        isCreating: false,
        createError: null,
    },
    reducers: {
        getAddresses(state) {
            state.isLoaded = false;
        },
        setAddresses(state, action) {
            state.addresses = action.payload;
            state.isLoaded = true;
        },

        createAddress(state, action) {
        },
        createAddressRequest(state) {
            state.isCreating = true;
            state.createError = null;
        },
        createAddressSuccess(state, action) {
            state.isCreating = false;
            state.addresses.push(action.payload);
        },
        createAddressFailure(state, action) {
            state.isCreating = false;
            state.createError = action.payload;
        },
    },
});

export const {
    getAddresses,
    setAddresses,
    createAddress,
    createAddressRequest,
    createAddressSuccess,
    createAddressFailure,
} = addresses.actions;

export default addresses.reducer;
